export var CronType;
(function (CronType) {
    CronType[CronType["Minutely"] = 0] = "Minutely";
    CronType[CronType["Hourly"] = 1] = "Hourly";
    CronType[CronType["Daily"] = 2] = "Daily";
    CronType[CronType["Weekly"] = 3] = "Weekly";
    CronType[CronType["Monthly"] = 4] = "Monthly";
    CronType[CronType["Advanced"] = 5] = "Advanced";
})(CronType || (CronType = {}));
var CustomCron = /** @class */ (function () {
    function CustomCron(flatObj) {
        if (!flatObj) {
            flatObj = {
                type: 0,
                minutely: {
                    atMinute: 1,
                },
            };
        }
        this.type = flatObj.type != null ? flatObj.type : 0;
        this.minutely = flatObj.minutely ? flatObj.minutely : {};
        this.hourly = flatObj.hourly ? flatObj.hourly : {};
        this.hourly.frequencyInHours = !!this.hourly.frequencyInHours ? this.hourly.frequencyInHours : 1;
        this.hourly.atMinute = !!this.hourly.atMinute ? this.hourly.atMinute : 0;
        this.daily = flatObj.daily ? flatObj.daily : {};
        this.daily.atHour = !!this.daily.atHour ? this.daily.atHour : 0;
        this.daily.atMinute = !!this.daily.atMinute ? this.daily.atMinute : 0;
        this.weekly = flatObj.weekly ? flatObj.weekly : { weekdays: [] };
        this.weekly.atHour = !!this.weekly.atHour ? this.weekly.atHour : 0;
        this.weekly.atMinute = !!this.weekly.atMinute ? this.weekly.atMinute : 0;
        this.monthly = flatObj.monthly ? flatObj.monthly : { weekdays: [] };
        this.monthly.atMinute = !!this.monthly.atMinute ? this.monthly.atMinute : 0;
        this.monthly.atHour = !!this.monthly.atHour ? this.monthly.atHour : 0;
        this.advancedCronExpression = flatObj.advancedCronExpression ? flatObj.advancedCronExpression : '';
    }
    Object.defineProperty(CustomCron.prototype, "cronExpression", {
        get: function () {
            var daysOfWeek, dayOfMonth;
            switch (this.type) {
                case CronType.Minutely:
                    return "0 0/" + this.minutely.atMinute + " * 1/1 * ? *";
                case CronType.Hourly:
                    return "0 " + this.hourly.atMinute + " 0/" + this.hourly.frequencyInHours + " 1/1 * ? *";
                case CronType.Daily:
                    return "0 " + this.daily.atMinute + " " + this.daily.atHour + " 1/1 * ? *";
                case CronType.Weekly:
                    daysOfWeek = this._formatDaysOfWeek(this.weekly.weekdays);
                    dayOfMonth = this._getNeutralDayOfMonth(daysOfWeek);
                    return "0 " + this.weekly.atMinute + " " + this.weekly.atHour + " " + dayOfMonth + " * " + daysOfWeek + " *";
                case CronType.Monthly:
                    daysOfWeek = this._formatDaysOfWeek(this.monthly.weekdays);
                    dayOfMonth = this._getNeutralDayOfMonth(daysOfWeek);
                    return "0 " + this.monthly.atMinute + " " + this.monthly.atHour + " " + dayOfMonth + " 1/" + this.monthly.frequencyInMonths + " " + daysOfWeek + " *";
                case CronType.Advanced:
                    return this.advancedCronExpression;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    CustomCron.prototype.normalize = function () {
        // clean unused data
        if (this.type !== CronType.Minutely) {
            this.minutely.atMinute = undefined;
        }
        if (this.type !== CronType.Hourly) {
            this.hourly.atMinute = undefined;
            this.hourly.frequencyInHours = undefined;
        }
        if (this.type !== CronType.Daily) {
            this.daily.atHour = undefined;
            this.daily.atMinute = undefined;
        }
        if (this.type !== CronType.Weekly) {
            this.weekly.weekdays = [];
            this.weekly.atHour = undefined;
            this.weekly.atMinute = undefined;
        }
        if (this.type !== CronType.Monthly) {
            this.monthly.weekdays = [];
            this.monthly.frequencyInMonths = undefined;
            this.monthly.atHour = undefined;
            this.monthly.atMinute = undefined;
        }
        if (this.type !== CronType.Advanced) {
            this.advancedCronExpression = '';
        }
    };
    CustomCron.prototype._getNeutralDayOfMonth = function (dayOfWeek) {
        return dayOfWeek === '?' ? '1/1' : '?';
    };
    CustomCron.prototype._formatDaysOfWeek = function (daysOfWeek) {
        return (daysOfWeek && daysOfWeek.length) ?
            daysOfWeek.map(function (day) { return day.id; }).join(',') :
            '?';
    };
    return CustomCron;
}());
export { CustomCron };
